<template>
  <div class="container" style="background-color: #fff;">
    <HeaderComponent :menu-id="2"></HeaderComponent>
    <div class="title-ty" style="background-color: #FFFAF4; position: relative; padding-bottom: 50px;">
      <img class="xiaci-border" style="bottom: -30px;" src="@/assets/image/border-bj-h.png" alt="">
      <div class="title-ty-y">SHUISHI GRADING</div>
      <div class="title-ty-z"><span>古钱币送评</span>评级标准</div>
    </div>
    <div class="content">
      <ul class="biaozhun-list">
        <li class="biaozhun-item" v-for="item in biaoZhunList">
          <div class="biaozhun-item-title">{{ item.title }}</div>
          <div class="biaozhun-item-fen"><span v-for="fen in item.fenList">{{ fen }}</span></div>
          <div class="biaozhun-item-text"><span v-for="text in item.textList">{{ text }}</span></div>
        </li>
      </ul>
    </div>
    <!-- 瑕疵说明 -->
      <div class="xiaci-container">
        <img class="xiaci-border" style="top: -50px;" src="@/assets/image/border-bj.png" alt="">
        <div class="xiaci-box">
          <div class="xiaci-title">古钱币瑕疵说明</div>
          <ul class="xiaci-list">
            <li class="xiaci-item" v-for="item in xiaCiList">{{ item.id }} - {{ item.text }}</li>
          </ul>
          <div class="xiaci-tag">- 存在以上情况的送评钱币一概不予评分，对可封装的钱币，封装盒将标注瑕疵代码，不可封装的钱币原路退回，正常收费。</div>
          <div class="xiaci-tag" style="color: #917C47;">- 注：鉴定为赝品的钱币，钱币不装盒，费用照常收取。鉴定结果为"无法判断"，返还钱币，不收取鉴定费用。</div>
        </div>
      </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
      biaoZhunList: [
        {
          id: 1,
          title: '完美',
          fenList: ['90','92'],
          textList: [ '1.完全未流通', '2.无铸造缺陷', '3.文字高挺无粘连', '4.包浆自然或锈色艳丽' ]
        },
        {
          id: 2,
          title: '极美',
          fenList: ['84','86','88'],
          textList: [ '1.近未流通', '2.无铸造缺陷', '3.文字清晰基本无粘连', '4.包浆自然或锈色艳丽' ]
        },
        {
          id: 3,
          title: '美品',
          fenList: ['78','80','82'],
          textList: [ '1.正常流通', '2.无大的铸造缺陷', '3.部分文字或笔画有粘连', '4.包浆、锈色自然' ]
        },
        {
          id: 4,
          title: '上品',
          fenList: ['70','72','75'],
          textList: [ '1.有磕碰', '2.有铸造上的', '3.文字可识', '4.包浆、锈色不美观' ]
        },
        {
          id: 5,
          title: '真品',
          fenList: ['70分以下'],
          textList: ['1.特殊要求评级', '2.后刻花', '3.文字不可识别','4.有修补等瑕疵']
        }
      ],
      xiaCiList: [
        {
          id: '03',
          text: '修补品，钱体出现的缺损、漏裂、破等现象加以修复完整'
        },
        {
          id: '04',
          text: '后加刀，明显改变钱体原本面貌'
        },
        {
          id: '05',
          text: '钱体在流通过程中形成的"裂"并对钱体声音有影响、钱体表征可视'
        },
        {
          id: '06',
          text: '破损'
        }
      ]
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
  .content{
    background-color: #fff;
    width: 1200px;
    margin: 0 auto;
  }
</style>